import React from "react"
import { INFLUENCER_PLATFORMS } from "../constants"

/**
 * Platform filter for the Influencer Explorer's leaderboard, sitting
 * directly in the toolbar (left of the Filters button) as an always-visible
 * pill row rather than tucked inside the filters modal.
 *
 * Unlike a tab this toggles independently: `platform` here is a genuine
 * multi-select API filter (TOP_INFLUENCER_FILTERS.md §2 - "(TikTok or
 * Instagram)"), not an exclusive switch, so more than one can be active at
 * once. No selection means every platform, same as leaving the filter off.
 */
const InfluencerPlatformToggle = ({ value, onChange }) => {
    const toggle = (id) => {
        onChange(value.includes(id) ? value.filter(v => v !== id) : [...value, id])
    }

    return (
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {INFLUENCER_PLATFORMS.map((platform) => {
                const isActive = value.includes(platform.id)
                return (
                    <button
                        key={platform.id}
                        type="button"
                        onClick={() => toggle(platform.id)}
                        title={`${isActive ? "Remove" : "Add"} ${platform.label}`}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                            padding: "8px 14px",
                            borderRadius: "10px",
                            fontSize: "13px",
                            fontWeight: 600,
                            fontFamily: "Rubik",
                            border: isActive ? `1px solid ${platform.color}` : "1px solid rgba(255,255,255,0.08)",
                            background: isActive ? `${platform.color}18` : "rgba(255,255,255,0.02)",
                            color: isActive ? "#fff" : "#9ca3af",
                            cursor: "pointer",
                        }}
                    >
                        <i className={platform.icon} style={{ color: platform.color, fontSize: "13px" }} />
                        {platform.label}
                    </button>
                )
            })}
        </div>
    )
}

export default InfluencerPlatformToggle
